import React, {Component} from 'react';

import {UserModuleMarketingContent} from "./UserModuleMarketingContent";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class UserModuleMarketingClass extends Component {
    constructor(props) {
        super(props);
        this.afterSuccessfulUserUpdated = this.afterSuccessfulUserUpdated.bind(this);
    }

    afterSuccessfulUserUpdated() {
        const { t } = this.props;
        alert(t('user.user_updated_successfully'))
    }

    renderContent() {
        return <UserModuleMarketingContent userId={this.props.match.params.id}
                                           afterSuccessfulUserUpdated={this.afterSuccessfulUserUpdated}/>
    }

    render() {
        return this.renderContent();
    }
}

const UserModuleMarketing = withRouterParams(withTranslation()(UserModuleMarketingClass));
export default UserModuleMarketing;
